var map = {
	"./delete.svg": [
		1470,
		470
	],
	"./down-arrow.svg": [
		8560,
		179
	],
	"./edit.svg": [
		7347,
		347
	],
	"./pencil.svg": [
		9676,
		676
	],
	"./up-arrow.svg": [
		1244,
		244
	],
	"./view.svg": [
		4464,
		464
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4502;
module.exports = webpackAsyncContext;